import { AgendamientoSpaResumido } from "../../services/agendamientosSpaServicios";
import { currencyFormat } from "../../utils/numberUtils";
import { IconContainer } from "./components/IconContainer";
import { InfoRow } from "./components/InfoRow";
import { ListaFechas } from "./components/ListaFechas";
import BathtubIcon from "@mui/icons-material/Bathtub";
import { SectionTitle } from "./components/SectionTitle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PaidIcon from "@mui/icons-material/Paid";

export const AgendamientoResumidoSpa = ({
  agendamiento,
}: {
  agendamiento: AgendamientoSpaResumido;
}) => {
  const reservaSpa = agendamiento.reservaSpa;
  const fechasSpa = agendamiento.reservaSpa.fechasProgramadas;
  return (
    <div>
      <h5>
        <IconContainer>
          <BathtubIcon />
        </IconContainer>
        Agendamiento de Spa
      </h5>
      <section className="mt-3">
        <div>
          <label className="mb-2 fw-bold" style={{ fontWeight: 500 }}>
            <IconContainer>
              <CalendarMonthIcon />
            </IconContainer>
            Fechas programadas:
          </label>
          <ListaFechas fechas={fechasSpa} />
        </div>
      </section>

      <section className="mb-4">
        <SectionTitle className="mb-3">
          <IconContainer>
            <PaidIcon />
          </IconContainer>
          Tarifas y planes
        </SectionTitle>
        {reservaSpa.tarifa && (
          <div className="mb-4">
            <InfoRow label="Tarifa" value={reservaSpa.tarifa!} />
            <InfoRow
              label="Valor final plan"
              value={currencyFormat(reservaSpa.precioFinalTarifa!)}
            />
          </div>
        )}
      </section>
    </div>
  );
};
